#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2026-03-24 09:48+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: bn\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr "{0} {1, plural, one {নোড} other {নোড}}"

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{1}টির মধ্যে {0}টি ফাইল আপলোড হয়েছে"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} স্থায়ীভাবে মুছে ফেলা হবে।"

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr "{number_of_buckets, plural, one {বাকেট} other {বাকেট}}"

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr "{id} আইডিসহ {resourceTypeName} পাওয়া যায়নি"

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr "<0><1>ব্যক্তি/মালিকানাধীন: জাতীয় পরিচয়পত্র (NID), পাসপোর্ট, অথবা ড্রাইভিং লাইসেন্স।</1><2>কোম্পানি/কর্পোরেট: ট্রেড লাইসেন্স।</2><3>আর্থিক ও আইনগত: কর শনাক্তকরণ নম্বর (TIN), ভ্যাট সার্টিফিকেট।</3></0>"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "১টি বেয়ার মেটাল সার্ভার"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "১ দিন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "১ ঘণ্টা"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "0 দিয়ে শুরু হওয়া ১০ অঙ্কের TrueMoney মোবাইল নম্বর"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "৩ দিন"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr "৪ সপ্তাহ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "৬ ঘণ্টা"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "৭ দিন"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "এই বিলিং অ্যাকাউন্টের অধীন সব সেবায় একটি ছাড় প্রয়োগ করা হয়েছে।"

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "এই ব্যবহারকারীর নাম দিয়ে একটি ইউজার অ্যাকাউন্ট তৈরি করা হবে। এটি VM-এ লগ ইন করতে ব্যবহার করা যাবে। এতে ASCII অক্ষর, সংখ্যা, আন্ডারস্কোর এবং হাইফেন থাকতে পারে। এটি অবশ্যই একটি অক্ষর বা আন্ডারস্কোর দিয়ে শুরু হতে হবে। সর্বোচ্চ দৈর্ঘ্য ২৫ অক্ষর।"

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "ভার্চুয়াল প্রাইভেট ক্লাউড (VPC) হলো আপনার একাধিক রিসোর্সের জন্য একটি ব্যক্তিগত নেটওয়ার্ক ইন্টারফেস। VPC নেটওয়ার্ক কোনো অতিরিক্ত খরচ ছাড়াই উপলভ্য।"

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "গ্রহণ করুন"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "আমন্ত্রণ গ্রহণ করুন"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "গৃহীত"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "এই প্রবেশাধিকার আমন্ত্রণ গ্রহণ করলে আপনি \"{name}\" হিসেবে কাজ করার এবং ব্যবহারকারীর পক্ষে সব কার্যক্রম সম্পাদনের অনুমতি পাবেন।"

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "প্রবেশাধিকার"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "প্রবেশাধিকার শংসাপত্র"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "প্রবেশাধিকার অর্পণ"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "প্রবেশাধিকার গোষ্ঠী"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "আপনার সঙ্গে প্রবেশাধিকার শেয়ার করা হয়েছে"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "প্রবেশাধিকার আমন্ত্রণ"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "{0} থেকে প্রবেশাধিকার আমন্ত্রণ অপেক্ষমাণ আছে"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "অ্যাক্সেস কী ID"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "প্রবেশাধিকার নাম"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "প্রবেশাধিকার পরিসর"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "প্রবেশাধিকার ধরন"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "ব্যবহারকারীতে প্রবেশ করুন"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "অ্যাকাউন্টের বিস্তারিত তথ্য যাচাই করা হচ্ছে।"

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "অ্যাকাউন্টের বিস্তারিত তথ্য অবশ্যই যাচাই করতে হবে"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "অ্যাকাউন্ট আইডি"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "অ্যাকাউন্টের নাম"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "হিসেবে প্রবেশ করুন"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "<0>{0}</0> হিসেবে কার্যরত"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr "পদক্ষেপ নেওয়া প্রয়োজন"

#. Disk status
#. Service status
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "সক্রিয়"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "আপনার স্টোরেজের প্রকৃত খরচ আপনার প্রকৃত ব্যবহারের ভিত্তিতে ঘণ্টাভিত্তিক হিসাব করা হয়; অগ্রিম কোনো অর্থপ্রদান নেই। শুরু হওয়া প্রতি GB-এর জন্য মূল্য পরবর্তী পূর্ণ GB পর্যন্ত উপরের দিকে পূর্ণসংখ্যায় নির্ধারণ করা হয়।"

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "প্রকৃত মূল্য কম্পিউট ও স্টোরেজ ব্যবহারের উপর নির্ধারিত হয়। হাইবারনেট করা ক্লাস্টারের পারসিস্টেন্ট ভলিউমগুলোর জন্যও চার্জ প্রযোজ্য থাকবে। আরও বিস্তারিত তথ্যের জন্য বিলিং অ্যাকাউন্টের বর্তমান ব্যবহার দেখুন।"

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "যোগ করুন"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr "স্বয়ংক্রিয় টপ আপ সমর্থন করে এমন একটি পেমেন্ট পদ্ধতি যোগ করুন।"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "অতিরিক্ত ডিস্ক যোগ করুন"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr "অন্তত একটি ফরওয়ার্ডিং নিয়ম যোগ করুন"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr "অন্তত একটি টার্গেট সার্ভার যোগ করুন"

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "ভার্চুয়াল মেশিনের জন্য কাস্টম কনফিগারেশন যোগ করুন"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "নামের প্রথম অংশ যোগ করুন"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "আইপি যোগ করুন"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "নামের শেষ অংশ যোগ করুন"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "নাম যোগ করুন"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "নতুন পেমেন্ট পদ্ধতি যোগ করুন..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr "নতুন রিজার্ভেশন যোগ করুন"

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "নতুন নিয়ম যোগ করুন"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "নোড যোগ করুন"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "নোড পুল যোগ করুন"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "পেমেন্ট পদ্ধতি যোগ করুন"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "পরে অর্থপ্রদানের পদ্ধতি যোগ করুন"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "নিয়ম যোগ করুন"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "SSH কী যোগ করুন"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "সাব-ইন্টারফেস যোগ করুন"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "টার্গেট সার্ভার যোগ করুন"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "ব্যবহারকারী যোগ করুন"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "ব্যবহারকারী যোগ করুন"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "পেমেন্ট পদ্ধতি যোগ করা ব্যর্থ হয়েছে"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "ঠিকানা"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "ঠিকানার ২য় লাইন"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "অ্যাডমিন ভিউ"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "সব"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr "সব আইপি ঠিকানা"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr "সব অনুমতি"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "সব TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "সব UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "একটি ফ্লোটিং আইপি বরাদ্দ করুন এবং আপনার নেটওয়ার্ক পরিচালনা শুরু করুন।"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr "বরাদ্দ করা হয়েছে"

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "একটি নতুন IPv4 ঠিকানা বরাদ্দ করলে আপনি এটি আপনার বিদ্যমান কোনো রিসোর্সে বরাদ্দ করতে পারবেন বা ভবিষ্যতে ব্যবহারের জন্য সংরক্ষণ করতে পারবেন।"

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "ইতিমধ্যে একটি অ্যাকাউন্ট আছে?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "পরিমাণ"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr "অগ্রিম বিলকৃত পরিমাণ"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "পরিমাণ খুব কম"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "পরিমাণ ধনাত্মক হতে হবে"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "পরিমাণ ন্যূনতম টপ আপের চেয়ে কম হওয়া যাবে না"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "রিসোর্স তৈরি করতে একটি সক্রিয় বিলিং অ্যাকাউন্ট প্রয়োজন।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "এই ফিচারটি ব্যবহার করতে একটি সক্রিয় বিলিং অ্যাকাউন্ট প্রয়োজন।"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "নির্দেশনাসহ একটি ই-মেইল আপনাকে পাঠানো হয়েছে।"

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "একটি ত্রুটি ঘটেছে"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "যেকোনো"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "API নথিপত্র"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "API টোকেন"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "অ্যাপ ক্যাটালগ"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "চেহারা"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "ইনভয়েসের মাধ্যমে অর্থপ্রদানের জন্য আবেদন করুন"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "আপনি কি নিশ্চিত যে uuid {ifUuid} সহ সাব-ইন্টারফেসটি মুছে ফেলতে চান?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "আপনি কি নিশ্চিত যে পাবলিক কী \"{name}\" মুছে ফেলতে চান?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "আপনি কি নিশ্চিত যে আপনি লগ আউট করতে চান?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "এতে বরাদ্দ করুন"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "সংযুক্ত"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "যার সাথে বরাদ্দ"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "অন্তত একটি ইমেইল প্রয়োজন"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "অন্তত একটি আইপি প্রয়োজন"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "অন্তত একটি নোড পুলে অটোস্কেলারের সর্বনিম্ন মান ১ বা তার বেশি হতে হবে।"

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "ফায়ারওয়াল সংযুক্ত করুন"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "রিসোর্স সংযুক্ত করুন"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "সংযুক্ত"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "সংযুক্ত আছে"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "স্বয়ংক্রিয়"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "স্বয়ংক্রিয় আপডেট"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "স্বয়ংক্রিয় পেমেন্ট"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "স্বয়ংক্রিয় টপ আপ"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "স্বয়ংক্রিয় সিস্টেম-স্তরের ব্যাকআপ সক্রিয় আছে। আপনার সেবা পুনরুদ্ধার করতে ব্যাকআপ ইমেজগুলি ব্যবহার করুন। ব্যাকআপ ৭ দিন সংরক্ষিত থাকবে, অর্থাৎ আপনার কাছে সর্বশেষ ৭টি ব্যাকআপ থাকবে।"

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr "স্বয়ংক্রিয় সিস্টেম-স্তরের ব্যাকআপ সক্রিয় আছে। আপনার ভার্চুয়াল মেশিন পুনরুদ্ধার করতে বা পরিবর্তিত আকারের প্যারামিটারসহ ব্যাকআপ থেকে নতুন ভার্চুয়াল মেশিন তৈরি করতে ব্যাকআপ ইমেজ ব্যবহার করুন।"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "স্বয়ংক্রিয় আপডেটের মাধ্যমে প্রিভিউ সংস্করণগুলো আপডেট করা হবে না।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "স্বয়ংক্রিয়ভাবে টপ আপ করুন (সর্বনিম্ন <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "অটোস্কেলার সর্বোচ্চ"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "অটোস্কেলার সর্বনিম্ন"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "উপলভ্য"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "সক্রিয়"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "ফিরে যান"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "আপনার অ্যাকাউন্টে ফিরে যান"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "ব্যাকআপ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "ব্যালান্সের ইতিহাস"

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "বেয়ার মেটাল"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "বেয়ার মেটাল সার্ভার"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "মূল মুদ্রা"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "আপনার বিলিং অ্যাকাউন্ট যাচাই প্রক্রিয়া শুরু করুন।"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "নিচে একটি Linux সার্ভারে এই সাব-ইন্টারফেস কীভাবে কনফিগার করতে হয় তার একটি উদাহরণ দেওয়া হলো।"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr "বিল করা হয়েছে"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "বিলিং"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "বিলিং অ্যাকাউন্ট"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "বিলিং অ্যাকাউন্ট \"{title}\"-এ {discount_percentage}% ছাড় রয়েছে"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "বিলিং অ্যাকাউন্ট সীমিত"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "বিলিং অ্যাকাউন্টের নাম"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr "বিলিং অ্যাকাউন্ট ওভাররাইড"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Billing account suspended"
msgstr "বিলিং অ্যাকাউন্ট স্থগিত"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr "বিলিং অ্যাকাউন্টের যাচাইকরণ প্রত্যাখ্যান করা হয়েছে"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "বিলিং অ্যাকাউন্টসমূহ"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr "বিলিং চক্র"

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "বুট"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "ISO মিডিয়া থেকে বুট করুন"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr "বুট মোড"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "ভার্চুয়াল মেশিন বন্ধ থাকলেই শুধু বুট করা সম্ভব।"

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "{gatewayName} দ্বারা"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "টপ আপ চালিয়ে গেলে আপনি <0>শর্তাবলি</0>, <1>গোপনীয়তা নীতি</1> এবং <2>ফেরত নীতি</2>-তে সম্মত হচ্ছেন।"

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "ব্যাকআপ নিষ্ক্রিয় করলে আপনার ভার্চুয়াল মেশিন থেকে আর কোনো স্বয়ংক্রিয় ব্যাকআপ তৈরি হবে না। এ পর্যন্ত তৈরি হওয়া ব্যাকআপগুলো যেমন আছে তেমনই সংরক্ষিত থাকবে এবং আপনি সেগুলো এখনও ব্যবহার করতে পারবেন। প্রয়োজন হলে আপনি যেকোনো সময় আবার ব্যাকআপ সক্রিয় করতে পারবেন।"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "“গ্লোবাল” নির্বাচন করলে এই ব্যবহারকারী অ্যাকাউন্টের অধীন সব রিসোর্সে প্রবেশ করা যাবে। “গ্লোবাল” পরিসর নির্বাচন করার সময় সতর্ক থাকুন।"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "“সীমাবদ্ধ” নির্বাচন করলে প্রবেশাধিকার নির্বাচিত বিলিং অ্যাকাউন্টের অন্তর্ভুক্ত রিসোর্সে সীমাবদ্ধ থাকবে।"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "নিবন্ধন করার মাধ্যমে আপনি <0>সেবার শর্তাবলী</0>-তে সম্মত হচ্ছেন"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "ক্যাম্পেইন কোড"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "অ্যাক্সেস দেওয়া হয়েছে"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "বাতিল করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "আপলোড বাতিল করুন"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr "বাতিল করা হয়েছে"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "কার্ড নম্বর"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr "কার্ড যাচাইকরণ ব্যর্থ হয়েছে"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "পরিবর্তন করুন"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "পাসওয়ার্ড পরিবর্তন করুন"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "আমরা আপনার ইনবক্সে যে যাচাইকরণ লিঙ্কটি পাঠিয়েছি, সেটিতে ক্লিক করে আপনার পাসওয়ার্ড পরিবর্তন করুন।"

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "পাসওয়ার্ড পরিবর্তন করা যায়নি"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "ভার্চুয়াল মেশিন চালু থাকলেই শুধু পাসওয়ার্ড পরিবর্তন করা সম্ভব।"

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "আপনার নতুন রিসোর্সের জন্য একটি বিলিং অ্যাকাউন্ট নির্বাচন করুন, যাতে উপযুক্ত পেমেন্ট পদ্ধতির অধীনে আপনার রিসোর্সগুলো একত্রে রাখা যায়।"

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "যে বিলিং অ্যাকাউন্টে আপনি প্রবেশাধিকার ভাগ করতে চান, সেটি নির্বাচন করুন"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "আইপি যেই রিসোর্সে বরাদ্দ করবেন তা নির্বাচন করুন, অথবা এটি অবরাদ্দ অবস্থায় রাখুন। পরে যেকোনো সময় উপযুক্ত রিসোর্সে আইপিটি বরাদ্দ করতে পারবেন।"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr "ডিস্কটি সংযুক্ত করার জন্য একটি ভার্চুয়াল মেশিন নির্বাচন করুন, অথবা এটিকে বিচ্ছিন্ন রাখুন এবং পরে একটি ভার্চুয়াল মেশিনে সংযুক্ত করুন।"

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "আপনার রিসোর্সের জন্য বিদ্যমান VPC নেটওয়ার্ক থেকে একটি বেছে নিন অথবা একটি নতুন প্রাইভেট নেটওয়ার্ক তৈরি করুন।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "বিলিং অ্যাকাউন্ট বেছে নিন"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "পদ্ধতি নির্বাচন করুন"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "টার্গেট সার্ভারগুলো যে VPC নেটওয়ার্কে আছে তা নির্বাচন করুন।"

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr "আপনি যে VM ইমপোর্ট করছেন সেটির প্রয়োজন হলে UEFI নির্বাচন করুন।"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "শহর"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "পরিষ্কার করা হচ্ছে"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "সব মুছুন"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr "ওভাররাইড অপসারণ করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "আপলোড তালিকা পরিষ্কার করুন"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr "PayPal-এর সঙ্গে সংযোগ করতে বোতামে ক্লিক করুন।"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "ক্লোন করুন"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "রিসোর্স ক্লোন করুন"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "বন্ধ করুন"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr "কোড:"

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr "প্রতিশ্রুতিবদ্ধ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "কোম্পানির নাম"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "কোম্পানির RNE নম্বর"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "কোডের নমুনাসহ পূর্ণাঙ্গ API নির্দেশিকা এখানে পাওয়া যাবে:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "কম্পিউট"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr "নিজে কনফিগার করুন"

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "ইমেইল নিশ্চিত করুন"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "পাসওয়ার্ড নিশ্চিত করুন"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "আমরা আপনার ইনবক্সে যে যাচাইকরণ লিঙ্কটি পাঠিয়েছি, সেটিতে ক্লিক করে আপনার ইমেইল ঠিকানা নিশ্চিত করুন।"

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "নিশ্চিতকরণ"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "সংযুক্ত করুন"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr "প্রথমে PayPal-এর সঙ্গে সংযোগ করুন"

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "সংযুক্ত হচ্ছে"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "পেমেন্ট পদ্ধতি সংযুক্ত করা হচ্ছে"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "সংযোগের বিস্তারিত"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "যোগাযোগের ব্যক্তির নাম"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "যোগাযোগের ব্যক্তির ফোন নম্বর"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "সাপোর্টের সাথে যোগাযোগ করুন"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "চালিয়ে যান"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "কপি করা হয়েছে!"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "কপি"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "কনফিগ ক্লিপবোর্ডে কপি করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "পাবলিক URL কপি করুন"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "ক্লিপবোর্ডে কপি করুন"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "মূল সেবাসমূহ"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "দেশ"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr "কাউন্টি"

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "তৈরি করুন"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "তৈরি করুন"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "প্রথমে একটি বিলিং অ্যাকাউন্ট তৈরি করুন, তারপর আপনি রিসোর্স তৈরি করা শুরু করতে পারবেন।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "একটি ডেডিকেটেড বেয়ার মেটাল সার্ভার তৈরি করুন এবং সর্বোচ্চ কর্মক্ষমতায় আপনার অ্যাপ্লিকেশন চালান।"

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr "একটি নতুন {resourceTypeName} তৈরি করুন"

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "এই {siteName} অ্যাকাউন্টে অন্যান্য ব্যবহারকারী বা সিস্টেমকে কার্যক্রম সম্পাদনের অনুমতি দিতে নতুন প্রবেশাধিকার তৈরি করুন।"

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "একটি নতুন ডিস্ক তৈরি করুন এবং আপনার ডেটা সংরক্ষণ শুরু করুন।"

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "একটি নতুন রিসোর্স তৈরি করুন এবং কয়েক মিনিটের মধ্যেই আপনার সেবাগুলো চালু করুন।"

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "একটি নতুন রিসোর্স তৈরি করুন এবং আপনার নেটওয়ার্ক ব্যবস্থাপনা শুরু করুন।"

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "নতুন একটি সেবা তৈরি করুন এবং কয়েক মিনিটের মধ্যেই তা চালু করুন।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "একটি নতুন স্টোরেজ অ্যাকাউন্ট তৈরি করুন, কিছু বাকেট তৈরি করুন এবং স্কেলযোগ্য উপায়ে আপনার ডেটা সংরক্ষণ শুরু করুন — যত বাড়বে ব্যবহার, তত পরিশোধ।"

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr "একটি নতুন স্টোরেজ অ্যাকাউন্ট তৈরি করুন, কিছু বাকেট তৈরি করুন এবং আপনার ডেটা সংরক্ষণ শুরু করুন।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "একটি নতুন ভার্চুয়াল মেশিন তৈরি করুন অথবা অ্যাপ ক্যাটালগ থেকে কিছু বেছে নিয়ে কয়েক মিনিটের মধ্যেই আপনার সেবাগুলো চালু করুন।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "একটি ব্যক্তিগত VPC তৈরি করুন এবং আপনার নেটওয়ার্কগুলো পরিচালনা করা শুরু করুন।"

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "রিসোর্সের জন্য একটি পাবলিক IPv4 ঠিকানা তৈরি করুন"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr "আপনার ওয়ার্কলোডের জন্য অতিরিক্ত স্টোরেজ তৈরি করুন। ডিস্কটি কনফিগার করুন এবং এখন বা পরে একটি ভার্চুয়াল মেশিনে সংযুক্ত করুন।"

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "একটি অ্যাকাউন্ট তৈরি করুন"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "আমাদের API ব্যবহার করতে একটি API টোকেন তৈরি করুন।"

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "আরও একটি {0} তৈরি করুন"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "বিলিং অ্যাকাউন্ট তৈরি করুন"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "নতুন তৈরি করুন"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "তৈরি হয়েছে"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "তৈরি হয়েছে"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "তৈরির তারিখ"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "যেখান থেকে তৈরি"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "তৈরি হচ্ছে"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "API টোকেনের মাধ্যমে প্রবেশাধিকার তৈরি করলে আমাদের API-এর সঙ্গে ব্যবহারের জন্য আপনি একটি কী পাবেন।"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "ক্রেডিট"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Credit is added to this billing account automatically once the payment is received. Make sure the billing account ID is entered correctly."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "ক্রেডিট নোট {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr "বর্তমান"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr "বর্তমান বিলিং চক্র"

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr "বর্তমান পরিবর্তনগুলো বাতিল হয়ে যাবে।"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "বর্তমান ব্যবহার"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "বর্তমানে উপলভ্য নয়"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "কাস্টম"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "কাস্টম ISO ইমেজ"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr "গ্রাহক সহায়তা"

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "গাঢ়"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "ড্যাশবোর্ড"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "যে ডেটা সেন্টারে রিসোর্সটি অবস্থিত"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "যে ডেটা সেন্টারে রিসোর্সটি তৈরি করা হবে।"

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "ডেটা অনুপস্থিত"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "তারিখ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "প্রত্যাখ্যাত / স্থগিত"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "ডিফল্ট"

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "প্রবেশাধিকার অর্পণ করুন"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "আপনার ব্যবহারকারী বা বিলিং অ্যাকাউন্টে প্রবেশাধিকার অর্পণ করুন, যাতে বিশ্বস্ত ব্যবহারকারীরা আপনার রিসোর্সগুলো পরিচালনা করতে পারেন।"

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "নতুন প্রবেশাধিকার অর্পণ করুন"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "নির্বাচিত বিশ্বস্ত ব্যবহারকারীকে প্রবেশাধিকার অর্পণ করলে তিনি আপনার হয়ে কাজ করতে পারবেন এবং আপনার ব্যবহারকারী বা বিলিং অ্যাকাউন্টের পক্ষে সব কার্যক্রম সম্পাদন করতে পারবেন।"

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "মুছুন"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "ফ্লোটিং আইপি মুছে ফেলুন"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "মুছে ফেলা হয়েছে"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "\"{display_name}\" মুছে ফেললে এটি স্থায়ীভাবে অপসারণ করা হবে, এবং এরপর আর এতে প্রবেশ করা যাবে না।"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr "\"{display_name}\" মুছে ফেললে ইতিমধ্যে পরিশোধ করা একটি রিসোর্স ধ্বংস হয়ে যাবে। সহায়তার জন্য অনুগ্রহ করে সহায়তা বিভাগের সাথে যোগাযোগ করুন।"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "\"{name}\" মুছে ফেললে এই গোষ্ঠীর সব ব্যবহারকারীর আপনার হয়ে কাজ করার প্রবেশাধিকার স্থায়ীভাবে সরিয়ে ফেলা হবে।"

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "{count}টি {0, plural, one {আইটেম} other {আইটেম}} মুছে ফেলা হচ্ছে।"

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "একটি ব্যাকআপ মুছে ফেললে তা স্থায়ীভাবে সরিয়ে ফেলা হবে।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "বিলিং অ্যাকাউন্ট \"{title}\" মুছে ফেললে এটি স্থায়ীভাবে অপসারণ করা হবে। বিলিং অ্যাকাউন্টটি কেবল তখনই মুছে ফেলা যাবে, যদি এর সঙ্গে কোনো বকেয়া রিসোর্স সংযুক্ত না থাকে এবং এতে কোনো অব্যবহৃত ক্রেডিট না থাকে।"

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "\"{0}\" অর্থপ্রদানের পদ্ধতি মুছে ফেললে এটি বিলিং অ্যাকাউন্ট থেকে সরিয়ে দেওয়া হবে।"

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "একটি সেবা মুছে ফেললে আপনার ব্যাকআপগুলিও মুছে যাবে এবং এরপর সেবাটি আর পুনরুদ্ধার করা যাবে না।"

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "একটি স্ন্যাপশট মুছে ফেললে তা স্থায়ীভাবে সরিয়ে ফেলা হবে।"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "অ্যাক্সেস কী \"{accessKey}\" মুছে ফেললে এটি স্থায়ীভাবে সরিয়ে ফেলা হবে, এবং এর পরে এটি স্টোরেজ API-তে প্রবেশের জন্য ব্যবহার করা যাবে না।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "ক্রেডিট কার্ড \"{placeholder}\" মুছে ফেললে এটি বিলিং অ্যাকাউন্ট থেকে স্থায়ীভাবে সরিয়ে দেওয়া হবে।"

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "ডিস্ক মুছে ফেললে তা স্থায়ীভাবে সরিয়ে ফেলা হবে, এবং এরপর আর এতে প্রবেশ করা যাবে না।"

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "ফ্লোটিং আইপি ঠিকানা \"{0}\" মুছে দিলে এটি আপনার অ্যাকাউন্ট থেকে সরানো হবে এবং পাবলিক পুলে ছেড়ে দেওয়া হবে।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "ইনভয়েস পদ্ধতি মুছে ফেললে এটি বিলিং অ্যাকাউন্ট থেকে স্থায়ীভাবে সরিয়ে দেওয়া হবে।"

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "\"{display_name}\" সেবাটি মুছে ফেললে এটি স্থায়ীভাবে অপসারিত হবে, এবং এরপর আর এটি অ্যাক্সেস করা যাবে না।"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr "স্টোরেজ অ্যাকাউন্ট \"{title}\" মুছে ফেললে এটি স্থায়ীভাবে সরিয়ে ফেলা হবে এবং সংশ্লিষ্ট সব কী মুছে যাবে। সক্রিয় বাকেট থাকা অ্যাকাউন্ট মুছে ফেলা যাবে না।"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "স্টোরেজ বাকেট \"{name}\" মুছে ফেললে এটি স্থায়ীভাবে সরিয়ে ফেলা হবে, এবং এর ভেতরের কোনো ফাইল পরে আর অ্যাক্সেস করা যাবে না।"

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "\"{description}\" টোকেনটি মুছে ফেললে এটি স্থায়ীভাবে সরিয়ে ফেলা হবে, এবং এরপর এটি প্রমাণীকরণের জন্য ব্যবহার করা যাবে না।"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "ভার্চুয়াল মেশিন \"{name}\" মুছে ফেললে এটি স্থায়ীভাবে সরিয়ে ফেলা হবে, এবং এর পরে এটি আর অ্যাক্সেসযোগ্য থাকবে না।"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "ভার্চুয়াল মেশিন মুছে ফেললে আপনার ব্যাকআপ এবং স্ন্যাপশটও মুছে যাবে, এবং এর পরে মেশিনটি পুনরুদ্ধার করা যাবে না। আপনি যদি ব্যাকআপ এবং স্ন্যাপশট রাখতে চান, তাহলে এর পরিবর্তে মেশিনটি বন্ধ করার কথা বিবেচনা করুন।"

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "VPC নেটওয়ার্ক \"{name}\" মুছে দিলে এটি আপনার অ্যাকাউন্ট থেকে সরানো হবে।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "বিবরণ"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "গন্তব্যসমূহ"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "বিচ্ছিন্ন"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "নিষ্ক্রিয় করুন"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "ব্যাকআপ নিষ্ক্রিয় করুন"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "MFA নিষ্ক্রিয় করুন"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "নিষ্ক্রিয়"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "সংযোগ বিচ্ছিন্ন করুন"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "সংযোগ বিচ্ছিন্ন"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "ছাড়"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "ডিস্ক"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "ডিস্ক I/O"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "ডিস্কের আকার শুধু বাড়ানো যায়। এই কাজ পূর্বাবস্থায় ফেরানো যাবে না। ডিস্কের ন্যূনতম আকার:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "ডিস্কসমূহ"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "প্রদর্শিত মুদ্রা"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr "প্রদর্শিত নাম"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "নথি"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "নথির ফাইল"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "ডকুমেন্ট নম্বর"

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "ডাউনলোড করুন"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "কনফিগ ফাইল ডাউনলোড করুন"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "PDF ডাউনলোড করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "ফাইল এখানে ছেড়ে দিন"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "পরিশোধের শেষ তারিখ"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "ইমেইল"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "সম্পাদনা করুন"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr "\"{title}\" সম্পাদনা করুন"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "রক্ষণাবেক্ষণা সম্পাদনা করুন"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr "নাম সম্পাদনা করুন"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "নোড সম্পাদনা করুন"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "নিয়ম সম্পাদনা করুন"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "ইমেইল"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr "এই ইমেইল ডোমেইন ব্যবহার নিষিদ্ধ"

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "ইমেইল যাচাইকরণ ব্যর্থ হয়েছে"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "ইমেইল যাচাইকৃত"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "যে ইমেইলে ইনভয়েস ও রিপোর্ট পাঠানো হবে।"

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "খালি ডিস্ক (ISO বুটের জন্য)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "সক্রিয় করুন"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "MFA সক্রিয় করুন"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "এই অ্যাকাউন্টের সঙ্গে সংযুক্ত রিসোর্সে অন্যান্য ব্যবহারকারী বা সিস্টেমকে কার্যক্রম সম্পাদনের অনুমতি দিন।"

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "সক্রিয়"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr "শেষ তারিখ"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr "শেষের পোর্ট"

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr "শেষের পোর্টের নম্বর শুরুর পোর্টের নম্বরের চেয়ে বড় হতে হবে"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr "সমাপ্ত"

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "১ থেকে ৪০৯৪-এর মধ্যে একটি মান লিখুন"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr "শুধু সংখ্যা লিখুন"

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "{0}-এ টপ আপের পরিমাণ লিখুন (সর্বনিম্ন {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "ত্রুটি"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "পেমেন্ট পদ্ধতি যোগ করতে ত্রুটি হয়েছে"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr "ত্রুটি কোড: {code}"

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "কর্ম সম্পাদন করতে ত্রুটি হয়েছে"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr "পরিবর্তনগুলো সংরক্ষণ করতে ত্রুটি হয়েছে"

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr "প্রতি ব্যাকআপের আনুমানিক খরচ"

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "আনু. মাসিক খরচ"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "আনুমানিক মোট"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr "আনুমানিক খরচ"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr "প্রতি ব্যাকআপের আনুমানিক মূল্য প্রতি মাসে {priceWithDiscount}।"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr "প্রতি স্ন্যাপশটের আনুমানিক মূল্য প্রতি মাসে {priceWithDiscount}।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "রেফারেল লিংক বা কোডের মাধ্যমে সাইন আপ করে এবং একটি যাচাইকৃত পেমেন্ট পদ্ধতি যোগ করলে প্রতিটি নতুন ব্যবহারকারী {c_totalReceiverCredit} মূল্যের বিনামূল্যের ক্রেডিট পাবেন।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "রেফারেল প্রোগ্রামের মাধ্যমে সাইন আপ করে এবং অন্তত {c_minimumTopUp} টপ আপ করলে প্রতিটি নতুন ব্যবহারকারী {c_totalReceiverCredit} ক্রেডিট মূল্যের একটি বোনাস পাবেন।"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "উদাহরণ"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "বিনিময় হার"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "{vatSymbol} ব্যতীত"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "ফেইল-ওভার নোড"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr "সার্ভারের সাথে সংযোগ করতে ব্যর্থ হয়েছে"

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr "Digio লাইব্রেরি লোড করতে ব্যর্থ হয়েছে"

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr "PayPal লাইব্রেরি লোড করা যায়নি"

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr "পপআপ খোলা যায়নি, সম্ভবত পপআপ ব্লকার ব্যবহৃত হচ্ছে"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "ফাইল"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "ফাইলসমূহ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "ফাইল এখানে আপলোড করা হবে"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "ফায়ারওয়াল"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "ফায়ারওয়াল কোনো অতিরিক্ত খরচ ছাড়াই উপলভ্য।"

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "ফায়ারওয়ালের নাম"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "ফায়ারওয়াল এখন উপলভ্য"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "নামের প্রথম অংশ"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "ফ্ল্যাগ"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "ফ্লোটিং আইপি"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "ফোল্ডার"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "ফোল্ডারের নাম"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "রেফারেল প্রোগ্রামের মাধ্যমে সাইন আপ করে এবং অন্তত {c_minimumTopUp} টপ আপ করে এমন প্রতিটি নতুন ব্যবহারকারীর জন্য আপনি {c_promoterCredit} মূল্যের বিনামূল্যের ক্রেডিট পাবেন।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "আপনার রেফারেল কোড ব্যবহার করে সাইন আপ করে এবং একটি যাচাইকৃত পেমেন্ট পদ্ধতি যোগ করে এমন প্রতিটি নতুন ব্যবহারকারীর জন্য আপনি {c_promoterCredit} মূল্যের বিনামূল্যের ক্রেডিট পাবেন।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "ব্যবহার অনুযায়ী পরিশোধ বিলিং অ্যাকাউন্টের ক্ষেত্রে অ্যাকাউন্ট তৈরি ও যাচাই সম্পন্ন হওয়ার পর আপনি অর্থপ্রদানের পদ্ধতি নির্বাচন করতে পারবেন।"

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "স্ন্যাপশটের জন্য আপনি শুধু স্ন্যাপশট যে পরিমাণ স্টোরেজ ব্যবহার করবে তার জন্যই মূল্য পরিশোধ করবেন।"

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "জোরপূর্বক বন্ধ করুন"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "পাসওয়ার্ড ভুলে গেছেন"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "ফরওয়ার্ডিং নিয়মসমূহ"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "বিনামূল্যে"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "ঘনত্ব"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "শুরু"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "থেকে"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "সম্পূর্ণ পাথ"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr "সম্পূর্ণরূপে পরিচালিত ডেটাবেস, যাতে আপনি আপনার কোডে মনোযোগ দিতে পারেন।"

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "সম্পূর্ণরূপে পরিচালিত সেবা — আমরা অন্তর্নিহিত অবকাঠামো প্রস্তুত করা এবং সেবার ব্যবস্থাপনার দায়িত্ব নিই।"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr "ভবিষ্যৎ"

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "গেটওয়ে"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "GB ডিস্ক"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr "স্বয়ংক্রিয়ভাবে তৈরি করুন (প্রস্তাবিত)"

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "আমাদের <0>API</0> ব্যবহারের জন্য একটি API প্রবেশাধিকার টোকেন তৈরি করুন।"

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "গ্লোবাল"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr "ড্যাশবোর্ডে যান"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "GST নম্বর"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "h"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr "হ্যালো"

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "হ্যালো বিশ্ব!"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "হাইবারনেট করুন"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "হাইবারনেট করা"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "হাইবারনেট করা হচ্ছে"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "লুকান"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "বিস্তারিত লুকান"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "উচ্চ প্রাপ্যতার লোড ব্যালান্সার একই ডেটা সেন্টার অবস্থানের মধ্যে ভার্চুয়াল মেশিনগুলোর মধ্যে ট্রাফিক বিতরণ করে।"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "ঘণ্টা"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr "ঘণ্টাভিত্তিক"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr "শুধুমাত্র ঘণ্টাভিত্তিক বিলিং চক্র"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "বর্তমান বিলিং সময়সীমার ব্যবহারের তথ্য প্রতি ঘণ্টায় হালনাগাদ করা হয়।"

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "অ্যাক্সেস পাওয়া গেছে"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "আমি <0>সেবার শর্তাবলী</0> পড়েছি এবং এতে সম্মত"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "আমি বুঝেছি যে মুছে ফেলা স্থায়ী"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "কম ব্যালান্স বিজ্ঞপ্তি সক্রিয় থাকলে এবং ব্যালান্স নির্ধারিত সীমার নিচে নেমে গেলে আপনাকে জানানো হবে।"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr "সক্রিয় রিজার্ভেশনের মেয়াদ শেষ হয়ে গেলে এবং তা নবায়ন না করা হলে প্রচলিত ঘণ্টাভিত্তিক মূল্য প্রযোজ্য হবে।"

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "ইনভয়েস পেমেন্ট পদ্ধতি যদি সঙ্গে সঙ্গে সক্রিয় না হয়, তবে আমরা আরও বিস্তারিত তথ্যসহ আপনার সঙ্গে যোগাযোগ করব। যদি শিগগিরই আমাদের কাছ থেকে ইমেইল না পান বা ইনভয়েস পেমেন্ট সক্রিয় না হয়, তাহলে <0/>-এ আমাদের সঙ্গে যোগাযোগ করতে পারেন।"

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "আপনার কোনো প্রশ্ন থাকলে, কোনো বাগ পেলে বা কোনো ফিচারের অনুরোধ থাকলে নির্দ্বিধায় <0>সাপোর্ট</0>-এর মাধ্যমে আমাদের সঙ্গে যোগাযোগ করুন।"

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr "সব হিসাবের ক্ষেত্রে নির্দিষ্ট সংখ্যক ঘণ্টা ব্যবহার করা হয়: এক মাসের জন্য 730, এক ত্রৈমাসিকের জন্য 2190 এবং এক বছরের জন্য 8760।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "ব্যবহৃত"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "নিষ্ক্রিয়"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "ইনবাউন্ড"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "ইনবাউন্ড নিয়মসমূহ"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr "VM-এর মূল্যের অন্তর্ভুক্ত"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "ইনকামিং ট্রাফিক কেবল নির্দিষ্ট পোর্টগুলোতে অনুমোদিত হবে, যদি তা নির্দিষ্ট উৎসগুলো থেকে আসে। অন্য সব ট্রাফিক ব্লক করা হবে।"

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "বর্ণনামূলক নাম। এটি VM-এর জন্য একটি উপযুক্ত হোস্টনেম তৈরি করতেও ব্যবহৃত হবে (যদি প্রযোজ্য হয়)।"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "অবকাঠামো"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "ইনিশিয়ালাইজেশন স্ক্রিপ্ট"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "কোড লিখুন"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "যে {siteName} ব্যবহারকারীকে আপনি প্রবেশাধিকার অর্পণ করতে চান, তার ইমেইল লিখুন। ব্যবহারকারীকে তার প্রোফাইল ভিউ থেকে প্রবেশাধিকার আমন্ত্রণ গ্রহণ করতে হবে।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "অপর্যাপ্ত তহবিল"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "ইন্টিগ্রেশন আইডি"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr "মাসটি সঠিক নয়"

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr "সার্ভার থেকে অবৈধ প্রতিক্রিয়া। Stormwall দ্বারা অবরুদ্ধ।"

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr "সার্ভার থেকে অবৈধ প্রতিক্রিয়ার ধরন: JSON-এর পরিবর্তে {ct} পাওয়া গেছে।"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr "নিবন্ধন করা যায়নি। অ্যাকাউন্টটি ইতিমধ্যে থাকতে পারে।"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr "বছরটি সঠিক নয়"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Invoice"
msgstr "ইনভয়েস"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "ইনভয়েস {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "ইনভয়েসের বিবরণ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "ইনভয়েস ইমেইল"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr "চালানটি পরিশোধ করা হয়েছে"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr "চালানটি পরিশোধযোগ্য নয়"

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr "চালানের নাম"

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "ইনভয়েস"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "আইপি"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "আইপি ঠিকানা"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr "আইপি ঠিকানা বা CIDR পরিসর"

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "অনুমোদিত আইপি তালিকা"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "আইপি প্রিফিক্সসমূহ"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr "আইপি পরিসর"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "IPv4 পরিসর"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "IPv6 পরিসর"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "ISO বুট"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "ইস্যুর তারিখ"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "জারির তারিখ"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "ফ্লোটিং আইপি রাখুন"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "মনে রাখবেন, সব কার্যকলাপ ট্র্যাক করা হবে এবং সেগুলো আপনার সঙ্গে সম্পর্কিত হিসেবে শনাক্ত করা যাবে।"

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr "কী-এর নাম"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Kubernetes প্যাচ সংস্করণ"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Kubernetes প্যাচ সংস্করণের স্বয়ংক্রিয় আপডেট"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "Kubernetes সেবা তৈরি করা যাবে না।"

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "ভাষা"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "সর্বশেষ পরিবর্তিত"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "নামের শেষ অংশ"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "সর্বশেষ ব্যাকআপ"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "সর্বশেষ স্ন্যাপশট"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "কম বিস্তারিত"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "হালকা"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "মোট টপ আপের পরিমাণ <0/>-এ পৌঁছালে সীমাবদ্ধতা অপসারণ করা হবে।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "সীমিত"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "সংযুক্ত রিসোর্সসমূহ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "তালিকামূল্য"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "লোড ব্যালান্সার"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "আরও লোড করুন"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "পেমেন্ট প্রদানকারী লোড করা হচ্ছে"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "লোড হচ্ছে..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "অবস্থান"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "লগ ইন"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Google দিয়ে লগ ইন করুন"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "লগ আউট"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr "লগ ইন করা হচ্ছে"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr "লগ ইন করতে ত্রুটি হয়েছে"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "আগে একটু দেখে নিন"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "স্বয়ংক্রিয় টপ আপ সক্রিয় থাকায় কম ব্যালান্স বিজ্ঞপ্তি কার্যকর নয়।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "কম ব্যালেন্সের বিজ্ঞপ্তি"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "মেশিনের বিবরণ"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "মেশিনটি ক্লায়েন্টদের জন্য তাৎক্ষণিক লিজের জন্য উপলভ্য।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "মেশিনটি ক্লায়েন্ট ব্যবহার করছেন এবং এর জন্য চার্জ প্রযোজ্য হচ্ছে।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "মেশিনটি ক্লায়েন্ট অর্ডার করেছেন, কিন্তু এটি প্রয়োজনীয় কনফিগারেশন পূরণ করে না।<0/>প্রয়োজন অনুযায়ী কনফিগার করা হলে এটিকে “ব্যবহৃত” অবস্থায় সরান।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "মেশিনটি অনুপলভ্য অথবা মেরামতের প্রয়োজন।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "মেশিনটির ডিস্ক পরিষ্কার করার প্রয়োজন রয়েছে।"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "মেশিনের ধরন"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "রক্ষণাবেক্ষণ"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "পরিচালনা করুন"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "API কীসমূহ পরিচালনা করুন"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "পরিচালিত সেবা"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "পরিচালিত সেবাসমূহ"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "সর্বোচ্চ সার্জ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "বড় করুন"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "আপলোডযোগ্য ফাইলের সর্বোচ্চ আকার {maxFileSizeInMB} MB"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "পদ্ধতি"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "যাচাই সম্পন্ন হওয়ার পর উপলভ্য পদ্ধতিসমূহ"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "মেট্রিক্স"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "পারফরম্যান্সের কারণে এই রিসোর্সের মেট্রিক্স লোড করা হয়নি"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "আপনার ব্যবহারকারীর জন্য MFA সক্রিয় আছে।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "ছোট করুন"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "অনুপস্থিত"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "মোড"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "মাস"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr "মাসিক"

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "মাসিক খরচ"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "আরও বিস্তারিত"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "মাল্টি-ফ্যাক্টর প্রমাণীকরণ (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "প্রযোজ্য নয়"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "নাম"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "নাম (ন্যূনতম {minChars} অক্ষর)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "নাম খুব ছোট"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr "সাহায্য প্রয়োজন?"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "নেটওয়ার্ক"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "নেটওয়ার্ক ব্যান্ডউইথ"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "নেটওয়ার্ক ইন্টারফেসসমূহ"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "নেটওয়ার্কিং"

#: src/components/sidebar/SidebarList.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "নতুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "নতুন ফাইলের নাম"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "নতুন ফোল্ডার"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "নতুন ফোল্ডারের নাম"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "নতুন নেটওয়ার্ক"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "নতুন পাসওয়ার্ড"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "নতুন SSH কী"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr "NForce গ্রাহক আইডি"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "কোনো সক্রিয় কার্ড নেই"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr "কোনো তথ্য নেই"

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr "কোনো ফেইল-ওভার নেই"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "এখনও কেউ আপনার ব্যবহারকারী অ্যাকাউন্টে প্রবেশ করতে পারে না"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "এখনও কেউ আপনাকে প্রবেশাধিকার দেয়নি"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "বর্তমানে কোনো অর্থপ্রদান করা হবে না। আপনি যেকোনো সময় আপনার অর্থপ্রদানের পদ্ধতি পরিবর্তন করতে পারবেন।"

#: src/components/empty.tsx
msgid "No records"
msgstr "কোনো রেকর্ড নেই"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr "এই সার্ভারের জন্য কোনো রিজার্ভেশন বিলিং চক্র উপলভ্য নেই।"

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "কোনো ফলাফল পাওয়া যায়নি"

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr "বাকেটের সংখ্যা"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "ফাইলের সংখ্যা"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "রিসোর্সের সংখ্যা"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "নিয়মের সংখ্যা"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "নোড"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "নোড পুল"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "নোড পুল"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "নোড"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "নোট: আপনি যদি অনেকগুলো আইটেম মুছে ফেলেন, তবে মুছে ফেলার প্রক্রিয়ায় অসামঞ্জস্যপূর্ণ অবস্থা তৈরি হতে পারে, যেখানে কিছু আইটেম মুছে যাবে কিন্তু অন্যগুলো থেকে যাবে। এমন হলে একই কাজ আবার পুনরায় করুন।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "নোট: আপনার ফোল্ডারে যদি অনেক ফাইল থাকে, তবে নাম পরিবর্তনের প্রক্রিয়ায় সময় লাগবে এবং এতে এমন অসামঞ্জস্যপূর্ণ অবস্থা তৈরি হতে পারে যেখানে কিছু ফাইল নতুন স্থানে সরানো হবে, আর কিছু পুরোনো ফোল্ডারেই থেকে যাবে। এমন হলে একই ফোল্ডারের নাম আবার পরিবর্তন করে কাজটি পুনরায় করুন।"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "দ্রষ্টব্য! আপনি এই আমন্ত্রণ গ্রহণ করলে মালিক তা জানতে পারবেন। তবে তারা আপনার ব্যবহারকারী অ্যাকাউন্টে প্রবেশ করতে পারবেন না এবং আপনার কোনো রিসোর্স দেখতে বা সম্পাদনা করতে পারবেন না।"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "বিজ্ঞপ্তিসমূহ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "ব্যালান্স এর নিচে নেমে গেলে জানান"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "ব্যালেন্স নিচের সীমার নিচে নেমে গেলে বিজ্ঞপ্তি দিন। মনে রাখবেন, প্রকৃত সীমা মূল মুদ্রায় নির্ধারিত হয়।"

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr "এখন পাওয়া যাচ্ছে"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "অফলাইন"

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "দিনে একবার"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "সপ্তাহে একবার (বুধবার ০২:০০ UTC-এ)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "আপনার একটি বিলিং অ্যাকাউন্টে সমস্যা রয়েছে এবং আপনার বাকেটগুলো সাময়িকভাবে স্থগিত করা হয়েছে। আরও তথ্যের জন্য <0>বিলিং অ্যাকাউন্টের বিস্তারিত</0> দেখুন অথবা সমস্যার সমাধানে সহায়তার সাথে যোগাযোগ করুন।"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "চলমান"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "চলমান ব্যালান্স"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "অনলাইন"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "শুধুমাত্র স্বয়ংক্রিয় পদ্ধতিসমূহ"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "শুধুমাত্র বুট ডিস্ক তৈরি করা হবে! সোর্স স্ন্যাপশটের OS কনফিগারেশনে অতিরিক্ত ডিস্কের প্রয়োজন থাকলে এর ফলে OS সঠিকভাবে বুট নাও হতে পারে।"

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "অপারেটিং সিস্টেম"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "অপারেটিং সিস্টেমের স্বয়ংক্রিয় আপডেট"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr "অথবা"

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "অর্ডার"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "অর্ডারসমূহ"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "OS"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "আউটবাউন্ড"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "আউটবাউন্ড নিয়মসমূহ"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "আউটগোয়িং ট্রাফিক কেবল নির্দিষ্ট গন্তব্যের নির্দিষ্ট পোর্টগুলোতে অনুমোদিত হবে। অন্য সব ট্রাফিক ব্লক করা হবে।"

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "বকেয়া পরিমাণ"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "পরিশোধিত"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "প্যারামিটার"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "পাসওয়ার্ড"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "ব্যবহারকারীর জন্য পাসওয়ার্ড। এতে অন্তত একটি ছোট হাতের এবং একটি বড় হাতের ASCII অক্ষর (a-z, A-Z), এবং অন্তত একটি সংখ্যা (0-9) থাকতে হবে। ন্যূনতম দৈর্ঘ্য ৮ অক্ষর।"

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "পাসওয়ার্ডগুলো মেলেনি"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr "অতীত"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "পাথ-স্টাইল URL"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr "পরিশোধ করুন"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "ইনভয়েস পরিশোধ করুন"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "এখনই পরিশোধ করুন"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Pay the total charge amount of <0>{chargeAmount}</0> with EVC Mobile Money to get {creditAmount} credits. Enter your billing account ID <1>{billingAccountId}</1> as the payment reference."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "ব্যবহার অনুযায়ী পরিশোধ (প্রস্তাবিত)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
msgid "Paying by invoice"
msgstr "ইনভয়েসের মাধ্যমে পরিশোধ"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "ইনভয়েসের মাধ্যমে পরিশোধ (প্রত্যাখ্যাত / স্থগিত)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "ইনভয়েসের মাধ্যমে পরিশোধ (মুলতুবি)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "পেমেন্ট অনুমোদন যাচাই সম্পন্ন হয়েছে।"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr "পেমেন্ট বাতিল করা হয়েছে"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr "উচ্চ ঝুঁকির কারণে পেমেন্ট বাতিল করা হয়েছে"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "অর্থপ্রদানের বিবরণ"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr "পেমেন্টে ত্রুটি"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr "পেমেন্ট ত্রুটি: {failure_message}{codeSuffix}"

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr "পেমেন্ট ব্যর্থ হয়েছে"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment method"
msgstr "অর্থপ্রদানের পদ্ধতি"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "পেমেন্ট পদ্ধতি"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "এই পদ্ধতিতে পেমেন্ট প্রক্রিয়া সম্পন্ন হতে কিছু সময় লাগে। প্রক্রিয়া সম্পূর্ণ হলে কেনা ক্রেডিট স্বয়ংক্রিয়ভাবে আপনার অ্যাকাউন্টে যোগ হবে।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "অর্থপ্রদানের ধরন"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr "পেমেন্ট বাতিল করা হয়েছে"

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "টি"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "অমীমাংসিত"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "সময়কাল"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "অনুমতিসমূহ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "ব্যক্তিগত পরিচয় নম্বর"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "ফোন নম্বর"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "প্ল্যাটফর্ম-প্রদত্ত"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "অনুগ্রহ করে স্বীকার করুন যে প্রশাসক আপনার অনুরোধ গ্রহণ না করা পর্যন্ত বিলিং অ্যাকাউন্ট সক্রিয় হবে না।"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "এই পেমেন্ট পদ্ধতি ব্যবহার করতে অনুগ্রহ করে পপ-আপ উইন্ডো অনুমোদন করুন"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "অনুগ্রহ করে ধৈর্য ধরুন"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "অনুগ্রহ করে পপআপ উইন্ডোতে পেমেন্ট সম্পন্ন করুন"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "সীমাবদ্ধতা অপসারণ করতে অনুগ্রহ করে সাপোর্টের সাথে যোগাযোগ করুন।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "আরও বিস্তারিত জানার জন্য অনুগ্রহ করে প্রশাসকদের সাথে যোগাযোগ করুন।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "অনুগ্রহ করে চালিয়ে যান।"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "অনুগ্রহ করে একটি বৈধ নাম লিখুন"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "অনুগ্রহ করে আপনার ইমেইল ঠিকানা লিখুন। আমরা আপনার পাসওয়ার্ড পুনঃসেট করার জন্য একটি ইমেইল পাঠাব।"

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "অনুগ্রহ করে ইমেইল যোগ করা সম্পূর্ণ করুন"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr "অনুগ্রহ করে মনে রাখবেন, আপনার স্টোরেজ বাকেটের সঙ্গে যুক্ত বিলিং অ্যাকাউন্টটি আপনার স্টোরেজ অ্যাকাউন্টের সঙ্গে সংশ্লিষ্ট বিলিং অ্যাকাউন্ট থেকে ভিন্ন। বিলিংয়ের সামঞ্জস্য এবং আরও স্পষ্ট ব্যবস্থাপনার জন্য এগুলো একই রাখার পরামর্শ দেওয়া হচ্ছে।"

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "আপনার রিসোর্সের খরচ কীভাবে গণনা করা হয় তা দেখুন।"

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "টার্গেট সার্ভার নির্বাচন করতে অনুগ্রহ করে একটি VPC নেটওয়ার্ক নির্বাচন করুন।"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "অনুগ্রহ করে তালিকা থেকে একটি আইটেম নির্বাচন করুন"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "যাচাইয়ের জন্য অনুগ্রহ করে ব্যবসা নিবন্ধন নথি বা পরিচয়পত্রের একটি কপি আপলোড করুন (সর্বোচ্চ {maxFileSizeInMB}MB)।"

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "এই ক্লাস্টারে হোস্ট করা পড ও সেবাগুলো বন্ধ হয়ে যাবে এবং যেকোনো ইফেমেরাল স্টোরেজ বাতিল করা হবে।"

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr "রিডাইরেক্ট থেকে পপআপ ফিরে আসেনি"

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr "লোড হওয়ার আগেই পপআপটি বন্ধ হয়ে গেছে"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "পোর্ট"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr "পোর্টের নম্বর 1 থেকে 65535-এর মধ্যে হতে হবে"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "পোর্ট পরিসর"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr "PostgreSQL মাল্টি-নোড সেটআপ হলো স্বয়ংক্রিয় ফেইল-ওভারসহ একটি প্রাইমারি/স্ট্যান্ডবাই সেটআপ।"

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr "অগ্রিম পরিশোধিত রিসোর্সসমূহ"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "অগ্রিম পরিশোধ"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "মূল্য"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "মূল্যতালিকা"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr "প্রতি চক্রের মূল্য"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "প্রতি ঘণ্টার মূল্য"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "প্রতি মাসের মূল্য"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "নিচের বিকল্পগুলোর জন্য মূল্য ভিন্ন হতে পারে"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "প্রাথমিক"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "ব্যক্তিগত"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "ব্যক্তিগত ইমেজ"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "প্রাইভেট আইপি"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "প্রাইভেট IPv4"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "প্রাইভেট নেটওয়ার্ক"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr "PayPal API-তে সমস্যা হয়েছে।"

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "প্রোফাইল"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "প্রোটোকল"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "JSON বা YAML আকারে একটি বৈধ cloud-config প্রদান করুন। এই কনফিগারেশনটি cloud-init user-data হিসেবে ভার্চুয়াল মেশিনে পাঠানো হবে। উপলভ্য সব অপশনের জন্য cloud-config সম্পর্কিত cloud-init ডকুমেন্টেশন দেখুন।"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "রক্ষণাবেক্ষণ সময়সীমার শুরুর সময়, যার মধ্যে প্রদানকারী স্বয়ংক্রিয় ক্লাস্টার আপডেটের সময়সূচি নির্ধারণ করতে পারে।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "সর্বজনীন"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "পাবলিক IP ঠিকানাগুলি নেটওয়ার্ক ভিউতে পরিচালিত হয়।"

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "পাবলিক IPv4"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "পাবলিক IPv6"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "পাবলিক কী"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "VM-এ লগইন করার জন্য SSH কী জোড়ার পাবলিক কী অংশ। এটি অবশ্যই <0>ssh-key-type base64encoded...key optional_comment</0> ফরম্যাটে হতে হবে।"

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "পাবলিক নেটওয়ার্ক"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "সর্বজনীন URL"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "পরিমাণ"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr "ত্রৈমাসিক"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr "ত্রৈমাসিক"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "RDP লিংক"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "আরও পড়ুন"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr "শুধুমাত্র পড়ার অনুমতি"

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "প্রস্তুত অবস্থা"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "প্রস্তুত"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "রিবুট"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "সাম্প্রতিক"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "পেমেন্ট গেটওয়েতে পুনর্নির্দেশ করা হচ্ছে"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "রেফারেল কোড"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "রেফারেল লিংক"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "রেফারেল প্রোগ্রাম"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Refresh credit"
msgstr ""

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "স্ট্যাটাস রিফ্রেশ করুন"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "নিবন্ধন নম্বর"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "পুনঃইনস্টল"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "\"{name}\" পুনঃইনস্টল করলে বুট ডিস্কের সব ডেটা মুছে যাবে এবং এটি প্রাথমিক পরিষ্কার OS অবস্থায় সেট হবে। সব স্ন্যাপশট এবং ব্যাকআপ সংরক্ষিত থাকবে।"

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "পুনরায় লোড করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "ডেটা পুনরায় লোড করুন"

#: src/root.tsx
msgid "Reload page"
msgstr "পৃষ্ঠাটি আবার লোড করুন"

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "অবশিষ্ট ক্রেডিট <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "রিসোর্স সরান"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "এই রিসোর্স থেকে পাবলিক IPv4 ঠিকানার বরাদ্দ সরিয়ে দিলে রিসোর্সটি পাবলিক ইন্টারনেট থেকে আর অ্যাক্সেসযোগ্য থাকবে না। আইপি ঠিকানাটি আপনার অ্যাকাউন্টে সংরক্ষিত থাকবে। বাম পাশের সাইডবারের নেটওয়ার্ক মেনু থেকে আপনি পাবলিক IPv4 ঠিকানাগুলো পরিচালনা করতে পারবেন।"

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "ব্যবহারকারী সরিয়ে দিলে \"{0}\"-এর আপনার হয়ে কাজ করার অধিকার প্রত্যাহার করা হবে।"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "নাম পরিবর্তন করুন"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "রিপোর্ট"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "রিপোর্ট {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "রিপোর্টসমূহ"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr "অনুরোধ করা হয়েছে"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr "রিজার্ভেশনসমূহ"

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "সংরক্ষিত"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr "<0/> পর্যন্ত রিজার্ভ করা এবং অগ্রিম পরিশোধিত ({daysRemaining} দিন বাকি)। মূল্য মাসিক সমতুল্য হিসেবে প্রদর্শিত।"

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "পাসওয়ার্ড রিসেট করুন"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "আকার পরিবর্তন করুন"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "ডিস্কের আকার পরিবর্তন করুন"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "ভার্চুয়াল মেশিন বন্ধ থাকলেই কেবল আকার পরিবর্তন করা সম্ভব।"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "রিসোর্সের নাম"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "রিসোর্সসমূহ"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "একই VPC নেটওয়ার্কের রিসোর্সসমূহ, প্রাইমারি ইন্টারফেসগুলোর প্রাইভেট ঠিকানা ব্যবহার করে"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "VLAN সাব-ইন্টারফেস দ্বারা শেয়ার করা VPC-গুলোর রিসোর্সসমূহ, তাদের নিজ নিজ প্রাইভেট ঠিকানা ব্যবহার করে"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr "প্রতিক্রিয়া প্রত্যাশার চেয়ে বেশি সময় নিচ্ছে বলে মনে হচ্ছে। কিছুক্ষণ অপেক্ষা করে পরিবর্তন দেখতে পৃষ্ঠাটি রিফ্রেশ করুন। ফলাফল সফলও হতে পারে, ব্যর্থও হতে পারে।"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr "প্রতিক্রিয়া প্রত্যাশার চেয়ে বেশি সময় নিচ্ছে বলে মনে হচ্ছে। কিছুক্ষণ অপেক্ষা করুন এবং পেমেন্টের অবস্থার পরিবর্তন দেখতে পৃষ্ঠাটি রিফ্রেশ করুন। যুক্তিসঙ্গত সময়ের মধ্যে পরিবর্তন না হলে অনুগ্রহ করে সহায়তা বিভাগের সাথে যোগাযোগ করুন।"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "পুনরুদ্ধার করুন"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "ব্যাকআপ থেকে পুনরুদ্ধার"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "স্ন্যাপশট থেকে পুনরুদ্ধার"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "ব্যাকআপ থেকে পুনরুদ্ধার করলে নির্বাচিত ব্যাকআপের অবস্থা দ্বারা সেবাটির বর্তমান অবস্থা প্রতিস্থাপিত হবে।"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr "এই ব্যাকআপটি পুনরুদ্ধার করলে বর্তমান অবস্থা প্রতিস্থাপিত হবে।"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr "এই স্ন্যাপশটটি পুনরুদ্ধার করলে বর্তমান অবস্থা প্রতিস্থাপিত হবে।"

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "সীমাবদ্ধ"

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr "সংরক্ষণকাল"

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "আবার চেষ্টা করুন"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr "AMD EPYC দিয়ে আপনার ক্লাউডে আমূল পরিবর্তন আনুন"

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "RNE নথি"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "সংযুক্ত সব ফায়ারওয়ালের নিয়ম একত্রে প্রয়োগ করা হয়; অন্তত একটি নিয়ম কোনো সংযোগকে অনুমতি দিলে সেই সংযোগ অনুমোদিত হবে।"

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "পূর্ণ নিয়ন্ত্রণ, নিরাপত্তা এবং সর্বোচ্চ কর্মক্ষমতার জন্য বেয়ার মেটাল সার্ভারে আপনার অ্যাপ্লিকেশন চালান। আপনার সবচেয়ে চাহিদাসম্পন্ন ব্যবহারের ক্ষেত্রে উপযোগী একটি ডেডিকেটেড সার্ভার প্রভিশন করুন।"

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "চালু"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "S3-সামঞ্জস্যপূর্ণ অবজেক্ট স্টোরেজ আপনাকে অগ্রিম কোনো অর্থপ্রদান ছাড়াই আপনার স্টোরেজ রিসোর্স প্রয়োজন অনুযায়ী বাড়ানো বা কমানোর সুযোগ দেয়। একটি নতুন স্টোরেজ অ্যাকাউন্ট তৈরি করুন, কিছু বাকেট তৈরি করুন এবং স্কেলযোগ্য উপায়ে আপনার ডেটা সংরক্ষণ শুরু করুন — যত বাড়বে ব্যবহার, তত পরিশোধ।"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "সংরক্ষণ করুন"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "পেমেন্টের তথ্য সংরক্ষণ করা হচ্ছে"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "পেমেন্ট করতে QR কোড স্ক্যান করুন"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "পরিসর"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "অনুসন্ধান"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "সিক্রেট অ্যাক্সেস কী"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "একটি ফাইল নির্বাচন করুন"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "একটি অর্থপ্রদানের পদ্ধতি নির্বাচন করুন"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "একটি বিকল্প নির্বাচন করুন"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "আপনার পছন্দের মুদ্রায় মূল্য দেখতে প্রদর্শিত মুদ্রা নির্বাচন করুন। প্রদর্শিত পরিমাণ ও বিনিময় হার কেবল নির্দেশক এবং তথ্যগত উদ্দেশ্যে দেওয়া হয়েছে। সব লেনদেন মূল মুদ্রা ({0})-তে প্রক্রিয়াকৃত হয়, এবং আপনার পেমেন্ট প্রদানকারীর হারের ভিত্তিতে চূড়ান্ত চার্জ ভিন্ন হতে পারে।"

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "আপনার পছন্দের মুদ্রা নির্বাচন করুন"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Ctrl+Alt+Del পাঠান"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "ইমেইল পাঠান"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "সার্ভার"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "সার্ভার শ্রেণি"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "সেবা"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "সেবার নাম"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "সেবাসমূহ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "ডিফল্ট হিসেবে সেট করুন"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "অবজেক্টের ACL 'private' করুন"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "অবজেক্টের ACL 'public-read' করুন"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "প্রবেশাধিকার দিন"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr "Facebook-এ শেয়ার করুন"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr "LinkedIn-এ শেয়ার করুন"

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr "X-এ শেয়ার করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "সাময়িকভাবে শেয়ার করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "শেয়ারের মেয়াদ"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "দেখান"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "বিস্তারিত দেখান"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "সর্বশেষ {limit}টি আইটেম দেখানো হচ্ছে"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "তালিকামূল্য দেখানো হচ্ছে। খরচের সারসংক্ষেপে ছাড় প্রয়োগ করা হয়েছে।"

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "নিবন্ধন করুন"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "Google দিয়ে নিবন্ধন করুন"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "আকার"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "আকার (GB)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "স্ন্যাপশট"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "সামাজিক মাধ্যমে শেয়ার"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "স্টক শেষ"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "সাজান"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "সাজান"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "তারিখ অনুযায়ী সাজান"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "নাম অনুযায়ী সাজান"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "আকার অনুযায়ী সাজান"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "সোর্স পোর্ট"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr "সোর্স পোর্টটি অবশ্যই অনন্য হতে হবে"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "উৎসসমূহ"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "SSH কী প্রয়োজনীয় প্যাটার্নের সাথে মেলে না"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "SSH কীসমূহ"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "SSH কীসমূহ আপনার <0>ইউজার প্রোফাইল</0>-এর অধীনে পরিচালনা করা যাবে।"

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "SSH লিংক"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "অপারেটিং সিস্টেমের প্রাথমিক সেটআপের কারণে root ব্যবহারকারীর জন্য SSH উপলভ্য নাও থাকতে পারে। অনুগ্রহ করে সিস্টেমে প্রবেশ করতে ভার্চুয়াল কনসোল ব্যবহার করুন এবং আপনার প্রয়োজন অনুযায়ী SSH সার্ভারের কনফিগারেশনে পরিবর্তন করুন।"

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "চালু করুন"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr "শুরুর তারিখ"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "এখান থেকে শুরু করুন"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "একটি নতুন নেটওয়ার্ক রিসোর্স তৈরি করে আপনার নেটওয়ার্ক ব্যবস্থাপনা শুরু করুন।"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr "শুরুর পোর্ট"

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr "শুরুর পোর্টটি অবশ্যই অনন্য হতে হবে"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "নতুন কিছু শুরু করুন"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "শুরুর সময়"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "পেমেন্ট শুরু করা হচ্ছে"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr "রাজ্য"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "অবস্থা"

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "বন্ধ করুন"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "বন্ধ"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "বন্ধ হচ্ছে"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "স্টোরেজ"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "স্টোরেজ অ্যাক্সেস কী"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr "স্টোরেজ অ্যাকাউন্ট"

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "স্টোরেজ বাকেট"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "স্টোরেজ বাকেটের নাম"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr "স্টোরেজ বাকেটসমূহ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "রাস্তার ঠিকানা"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "স্ট্রিং"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr "সাবনেট পরিসর (CIDR)"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "উপমোট"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "সহায়তা"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "স্থগিত"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "গ্রিড দৃশ্যে পরিবর্তন করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "তালিকা দৃশ্যে পরিবর্তন করুন"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "সিস্টেম"

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "আপনার ভার্চুয়াল মেশিনের বর্তমান অবস্থার একটি তাৎক্ষণিক ইমেজ তৈরি করতে একটি স্ন্যাপশট নিন। পরে আপনি এই স্ন্যাপশট ব্যবহার করে আপনার ভার্চুয়াল মেশিনের অবস্থা পুনরুদ্ধার করতে পারবেন অথবা পরিবর্তিত আকারের প্যারামিটারসহ স্ন্যাপশট থেকে একটি নতুন ভার্চুয়াল মেশিন তৈরি করতে পারবেন।"

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "স্ন্যাপশট নিন"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "কিছু পদক্ষেপ নিন, তাহলে আপনি আর কখনও এই ক্যাকটাসটি দেখবেন না।"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "টার্গেট পোর্ট"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "টার্গেট সার্ভারসমূহ"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "কনসোল"

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "সেবার শর্তাবলী"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "আপনার রিসোর্সের প্রকৃত খরচ নিচের মূল্য এবং আপনার প্রকৃত ঘণ্টাভিত্তিক ব্যবহারের ওপর ভিত্তি করে গণনা করা হয়। সব মূল্য প্রতি একক রিসোর্সের জন্য (1 vCPU বা 1 GiB)। মূল্যের মধ্যে কর অন্তর্ভুক্ত নয়।"

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "বিলিং অ্যাকাউন্টটি বন্ধ করা হয়েছে এবং এটি আর উপলভ্য নয়।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "সফলভাবে টপ আপ করার পরেই ক্যাম্পেইন কোড সক্রিয় হবে।"

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "সম্পূর্ণ ব্যবহারকারী ইন্টারফেস বদলে যাবে এবং আপনি যেন ওই ব্যবহারকারী, সেভাবে কাজ করবে। কাজ শেষ হলে হেডার বারের “Back to your account” বোতামে ক্লিক করে সেশন বন্ধ করতে পারবেন, এবং ব্যবহারকারী ইন্টারফেস আবার আপনার অ্যাকাউন্টে ফিরে যাবে।"

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "চূড়ান্ত বিনিময় হার এবং চার্জের পরিমাণ প্রকৃত পেমেন্টের সময় নির্ধারিত হবে।"

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "প্রথম টপ আপ করলে আপনার জন্য বিনামূল্যের <0><1/></0> ক্রেডিট আনলক হবে।"

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr "বিন্যাসটি হলো MM/YY"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "লিংকের মেয়াদ শেষ হবে:"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "নামে শুধুমাত্র ছোট হাতের অক্ষর, সংখ্যা এবং ড্যাশ থাকতে পারবে; এটি অবশ্যই ছোট হাতের অক্ষর বা সংখ্যা দিয়ে শুরু হতে হবে; অনুমোদিত দৈর্ঘ্য ৩–৬৩।"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "যেকোনো বিদ্যমান ব্যবহারকারী অ্যাকাউন্টের পাসওয়ার্ড পরিবর্তন করা যেতে পারে।"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "কোনো সমস্যা হলে যোগাযোগের জন্য ফোন/মোবাইল নম্বর"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "মূল্যটি আনুমানিক; আপনার রিসোর্সের খরচ আপনার প্রকৃত ঘণ্টাভিত্তিক ব্যবহারের ভিত্তিতে গণনা করা হবে।"

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "সঠিকভাবে প্রবেশ করানো হয়েছে কি না নিশ্চিত করতে পুনরায় টাইপ করা পাসওয়ার্ড।"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr "এই রিজার্ভেশন কিনতে নির্বাচিত বিলিং অ্যাকাউন্টে পর্যাপ্ত ক্রেডিট নেই।"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr "নির্বাচিত বিলিং অ্যাকাউন্টটি সীমিত এবং রিজার্ভেশন তৈরি করতে পারে না।"

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr "সাবনেটটি অবশ্যই নিচের যেকোনো একটি আইপি ব্লকের মধ্যে থাকতে হবে:"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "যে ব্যবহারকারী অ্যাকাউন্টের জন্য পাসওয়ার্ড সেট করা হবে।"

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "আপনার ইমেইল ঠিকানা যাচাই করতে একটি ত্রুটি হয়েছে।"

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "আপনার রিসোর্স তৈরি করার সময় একটি ত্রুটি হয়েছে।"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "এই শংসাপত্রগুলি শুধুমাত্র প্রাথমিক লগইনের জন্য। এগুলি অবিলম্বে পরিবর্তন করার পরামর্শ দেওয়া হচ্ছে।"

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr "এই {resourceTypeName} আর নেই"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "এই বেয়ার মেটাল সার্ভারটি এখনও সেট আপ করা হচ্ছে।"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "রিসোর্স তৈরি করার ক্ষেত্রে এই বিলিং অ্যাকাউন্টের সক্ষমতা সীমিত।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "এই বিলিং অ্যাকাউন্টটি সীমিত"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "এই ডিস্ট্রিবিউশনের লাইসেন্সের জন্য প্রতি ঘণ্টায় <0/> খরচ যোগ হয় (প্রতি মাসে <1/>)।"

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr "এই ঘরটি পূরণ করা আবশ্যক"

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr "এই কীটির এই স্টোরেজ অ্যাকাউন্টের অধীনে থাকা সব বাকেটে প্রবেশাধিকার রয়েছে। নির্দিষ্ট বাকেটে প্রবেশাধিকার সীমিত করতে একটি পৃথক স্টোরেজ অ্যাকাউন্ট তৈরি করুন।"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr "এই পৃষ্ঠাটি আর নেই"

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "এই সেবাটি কেবল একই VPC নেটওয়ার্কের রিসোর্সগুলো থেকে এই প্রাইভেট ঠিকানাগুলি ব্যবহার করে অ্যাক্সেস করা যাবে।"

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "এই ভার্চুয়াল মেশিনে প্রবেশ করা যাবে:"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "এটি ফায়ারওয়াল এবং এর সংশ্লিষ্ট নিয়মগুলো মুছে দেবে, এবং সেগুলো আর কোনো নির্ধারিত রিসোর্সে প্রযোজ্য হবে না।"

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "এটি আপনার রিসোর্স \"{name}\" জোরপূর্বক বন্ধ করবে। বন্ধ রিসোর্সের জন্য আপনাকে কেবল স্টোরেজের চার্জ দিতে হবে।"

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "এটি ক্লাস্টার \"{display_name}\"-কে হাইবারনেট করবে।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "এটি শুধুমাত্র সিস্টেমের ভেতরে ব্যবহার করা হবে, যাতে আপনার একাধিক অ্যাকাউন্ট থাকলে সহজে চিনতে পারেন।"

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "এটি আপনার রিসোর্স \"{name}\" রিবুট করবে।"

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "এটি অনুমোদিত আইপি তালিকা থেকে ঠিকানা বা রেঞ্জটি সরিয়ে দেবে।<0/>মনে রাখবেন, খালি অনুমোদিত আইপি তালিকা যেকোনো ঠিকানা থেকে সংযোগের অনুমতি দেবে।"

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "এটি আপনার রিসোর্স \"{display_name}\" বন্ধ করবে। যদি ১২০ সেকেন্ডের মধ্যে স্বাভাবিকভাবে বন্ধ করার প্রক্রিয়া সম্পন্ন না হয়, তাহলে জোরপূর্বক বন্ধ করা হবে। বন্ধ থাকা রিসোর্সের ক্ষেত্রে আপনাকে শুধু স্টোরেজের জন্য চার্জ করা হবে।"

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "এটি আপনার রিসোর্স \"{name}\" বন্ধ করবে। যদি স্বাভাবিকভাবে বন্ধ করার প্রক্রিয়া ১২০ সেকেন্ডের মধ্যে সম্পন্ন না হয়, তবে জোরপূর্বক বন্ধ করা হবে। বন্ধ রিসোর্সের জন্য আপনাকে কেবল স্টোরেজের চার্জ দিতে হবে।"

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "এটি টার্গেটগুলোতে ট্রাফিক ফরওয়ার্ড করা বন্ধ করবে এবং লোড ব্যালান্সারটি সরিয়ে দেবে।"

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "সীমা"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr "এগিয়ে যাওয়ার সময় হয়েছে। এখন কোথায় যেতে পারেন তার কিছু পরামর্শ এখানে দেওয়া হলো:"

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr "এগিয়ে যাওয়ার সময় হয়েছে। এই আইটেমটি মুছে ফেলা হয়েছে অথবা আপনার এটির প্রবেশাধিকার নেই।"

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr "Razorpay-এর উত্তরের জন্য অপেক্ষার সময়সীমা শেষ হয়েছে"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "সময় অঞ্চল"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "একটি বিলিং অ্যাকাউন্ট সক্রিয় করতে, অনুগ্রহ করে পেমেন্ট পদ্ধতি হিসেবে একটি ক্রেডিট কার্ড যোগ করুন অথবা ইনভয়েসের মাধ্যমে পরিশোধ সক্রিয় করতে সাপোর্টের সাথে যোগাযোগ করুন।"

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "সেবাটিতে সংযোগ সীমিত করতে আপনাকে অনুমোদিত আইপি তালিকায় অন্তত একটি ইনবাউন্ড আইপি যোগ করতে হবে (অন্যান্য সব পাবলিক ও প্রাইভেট সংযোগ প্রত্যাখ্যান করা হবে)। আপনি একটি একক IPv4 ঠিকানা বা CIDR নোটেশন ব্যবহার করে একাধিক ঠিকানার একটি ব্লক নির্দিষ্ট করতে পারেন (যেমন 1.1.1.0/24)।"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "প্ল্যাটফর্ম ব্যবহার শুরু করতে আপনাকে প্রথমে একটি বিলিং অ্যাকাউন্ট সেট আপ করতে হবে। সিস্টেমের সাথে পরিচিত হতে আপনি বিভিন্ন অংশ দেখে নিতে পারেন এবং যখন আপনার প্রথম রিসোর্স তৈরি শুরু করার জন্য প্রস্তুত হবেন, তখন যেকোনো সময় বিলিং অ্যাকাউন্ট তৈরিতে ফিরে আসতে পারেন।"

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "আমাদের সেবা ব্যবহার করতে হলে আপনাকে সেবার শর্তাবলীতে সম্মত হতে হবে।"

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "টোকেন"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "টপ আপ করুন"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "টপ আপের পরিমাণ"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "রেফারেল কোড বোনাস হিসেবে <2><3/></2> পেতে অন্তত <0><1/></0> টপ আপ করুন।"

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "এখনই টপ আপ করুন"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "আপনার অ্যাকাউন্টে টপ আপ করুন"

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "টপ আপ ইনভয়েস"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "টপ আপ অর্ডারসমূহ"

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "মোট"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "মোট চার্জ"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "মোট ({vatSymbol} ব্যতীত)"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "সব অপরিশোধিত ইনভয়েসের মোট। {vatSymbol} অন্তর্ভুক্ত।"

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "সব অপরিশোধিত অর্ডারের মোট। ভ্যাটসহ।"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "লেনদেন ফি"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "ধরন"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr "UEFI ভেরিয়েবল (NVRAM) রিবুটের পরেও সংরক্ষিত থাকবে না।"

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "UI"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "বরাদ্দ সরান"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "অসংযুক্ত"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "একক"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "অজানা"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr "অজানা Auth0 ত্রুটি"

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "অজানা বিলিং অ্যাকাউন্ট"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr "অজানা পেমেন্ট ত্রুটি{codeSuffix}"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "অজানা রিসোর্স"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "টার্গেটের সংযোগ সরান"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "অপরিশোধিত"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "অপরিশোধিত পরিমাণ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "যাচাই করা হয়নি"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "আপডেট করুন"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "SSH কী আপডেট করুন"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "আপলোড করুন"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "যাচাইয়ের জন্য শুধুমাত্র RNE নথির একটি কপি আপলোড করুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "ফাইল আপলোড করা হচ্ছে"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr "আপলোড এখনো চলছে। আপনি এই পৃষ্ঠা ছেড়ে গেলে অগ্রগতি আর দেখানো হবে না এবং আপলোড ব্যাহত হতে পারে। তবুও কি পৃষ্ঠা ছেড়ে যাবেন?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "ব্যবহার"

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "ভার্চুয়াল মেশিন তৈরি হওয়ার পরে নিজে অপারেটিং সিস্টেম ইনস্টল করতে ISO বুট অপশন ব্যবহার করুন।"

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "অ্যাক্সেস"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "ব্যবহারকারীকে তার প্রোফাইল ভিউ থেকে প্রবেশাধিকার আমন্ত্রণ গ্রহণ করতে হবে"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "ব্যবহারকারী ভিউ"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "ব্যবহারকারীর ইমেইল"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "ব্যবহারকারীর নাম"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "আমি যে ব্যবহারকারীদের অ্যাক্সেস করতে পারি"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "যেসব ব্যবহারকারী আমার অ্যাকাউন্টে প্রবেশ করতে পারেন"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "কার্যকর মেয়াদ"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "যাচাইকরণ মুলতুবি"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr "মানটি প্রয়োজনীয় প্যাটার্নের সাথে মেলে না"

#: src/components/VatText.tsx
msgid "VAT"
msgstr "ভ্যাট"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "ভ্যাট নম্বর"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "যাচাইকৃত"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "যাচাইকৃত পেমেন্ট পদ্ধতি নেই"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "পেমেন্ট পদ্ধতি যাচাই করা হচ্ছে"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "সংস্করণ"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "দেখুন"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "সব রেকর্ড দেখুন"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "কনফিগ কমান্ডসমূহ দেখুন"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "বিস্তারিত দেখুন"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "সর্বশেষ {limit}টি রেকর্ড দেখুন"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "আরও দেখুন"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "ভার্চুয়াল হোস্ট-স্টাইল URL"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "ভার্চুয়াল মেশিন"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "VLAN আইডি"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "VPC আইপি রেঞ্জ"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "VPC নাম"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "VPC নেটওয়ার্ক"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "VPC নেটওয়ার্ক কোনো অতিরিক্ত খরচ ছাড়াই উপলভ্য।"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "যাচাইকরণের জন্য অপেক্ষা করুন অথবা কার্ড যোগ করুন"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "পেমেন্ট নিশ্চিতকরণের জন্য অপেক্ষা করা হচ্ছে"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr "রিডাইরেক্ট থেকে পপআপ ফিরে আসার জন্য অপেক্ষার সময়সীমা শেষ হয়েছে"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "চালু করা হচ্ছে"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "সতর্কতা"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "সতর্কতা: বুট ডিস্কের আকার পরিবর্তনের আগে ভার্চুয়াল মেশিন বন্ধ করার পরামর্শ দেওয়া হয়।"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "আপনার অনুরোধ প্রক্রিয়াধীন থাকা অবস্থায় সেবাগুলো দ্রুত সক্রিয় করতে আমরা একটি ক্রেডিট কার্ড যোগ করার পরামর্শ দিচ্ছি।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "আমরা স্বয়ংক্রিয় টপ আপ করার পরামর্শ দিই, কারণ এতে ব্যালান্স শেষ হয়ে যাওয়ার ঝুঁকি কমে এবং ফলে আপনার সার্ভার রিসোর্স প্রভাবিত হওয়ার সম্ভাবনাও কমে।"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "শুরু করতে সহায়তার জন্য আমরা কিছু লিঙ্ক একত্র করেছি। প্রোটোটাইপিং থেকে বৃহৎ-পরিসরের ডেভেলপমেন্ট পর্যন্ত, দ্রুত আপনার অ্যাপ্লিকেশন তৈরি, কোড পরীক্ষা এবং ডিপ্লয় করুন।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "আমাদের ফাইল ব্রাউজারের ধারণক্ষমতার সীমায় পৌঁছে গেছে। ব্যবহারকারী ইন্টারফেসের স্থিতিশীলতা বজায় রাখতে আমরা আপনার বাকেটের বিষয়বস্তু লোড করা বন্ধ করেছি। অনুগ্রহ করে আপনার বাকেটের বিষয়বস্তু পরিচালনার জন্য প্রয়োজনীয় বাহ্যিক টুল ব্যবহার করুন"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "স্বাগতম"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "স্বাগতম!<0/>আপনাকে এখানে পেয়ে আমরা আনন্দিত।"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "আপনি কী করতে চান?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "ব্যালান্স এর নিচে নামলে"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "কোনো IPv4 ঠিকানা সংরক্ষিত থাকলেও যদি কোনো রিসোর্সে বরাদ্দ না থাকে, তবে এর জন্য প্রতি মাসে <0/> চার্জ করা হবে।"

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "এটি নির্বাচন করলে আপনার রিসোর্সের জন্য একটি পাবলিক ফ্লোটিং IPv4 ঠিকানা তৈরি হবে এবং স্বয়ংক্রিয়ভাবে বরাদ্দ করা হবে। আপনি যদি আপনার রিসোর্সে পাবলিক অ্যাক্সেস না চান, তবে এখানে এই বিকল্পটির নির্বাচন তুলে দিতে পারেন বা পরে আইপি ঠিকানাটি সরিয়ে দিতে পারেন।"

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "আপনি ব্যাকআপ সেবা সক্রিয় করলে বুট ডিস্ক থেকে (অতিরিক্ত ডিস্ক বাদে) স্বয়ংক্রিয় ডিস্ক-স্তরের ব্যাকআপ তৈরি হবে। প্রতি সপ্তাহে একবার একটি ব্যাকআপ তৈরি হবে এবং এখানে তালিকাভুক্ত হবে। পরে আপনি ব্যাকআপ ইমেজ ব্যবহার করে আপনার ভার্চুয়াল মেশিন পুনরুদ্ধার করতে পারবেন অথবা পরিবর্তিত আকারের প্যারামিটারসহ ব্যাকআপ থেকে একটি নতুন ভার্চুয়াল মেশিন তৈরি করতে পারবেন।"

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "কাজটি চলাকালীন আপনি যা করতে পারেন:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "ফায়ারওয়ালের মাধ্যমে আপনি পূর্বনির্ধারিত নিরাপত্তা নিয়মের ভিত্তিতে আগত ও বহির্গামী নেটওয়ার্ক ট্রাফিক নিয়ন্ত্রণ করতে পারেন।"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "প্রথম বিলিং অ্যাকাউন্টের মাধ্যমে আপনি আপনার বিনামূল্যের <0><1/></0> ক্রেডিট আনলক করতে পারবেন।"

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "নির্বাচিত পেমেন্ট পদ্ধতিতে, আপনাকে {0}-এ চার্জ করা হবে।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "সক্রিয় বিলিং অ্যাকাউন্ট ছাড়া আপনি কোনো রিসোর্স তৈরি করতে পারবেন না, শুরু করতে একটি তৈরি করুন।"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "সক্রিয় বিলিং অ্যাকাউন্ট ছাড়া রিসোর্স তৈরি করা যাবে না।"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr "বছর"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr "বার্ষিক"

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "হ্যাঁ"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "আপনি \"{name}\" ব্যবহারকারীতে প্রবেশ করতে চলেছেন"

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "আপনি একজন প্রশাসক এবং আপনার প্রশাসনিক বিশেষাধিকার অন্য একজন ব্যবহারকারীকে অর্পণ করতে যাচ্ছেন। অনুগ্রহ করে নিশ্চিত করুন যে এই কাজটি ইচ্ছাকৃত।"

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "উন্নত নিরাপত্তার জন্য আপনি মাল্টি-ফ্যাক্টর প্রমাণীকরণ সক্রিয় করতে পারেন। এটি শুধুমাত্র ব্যবহারকারীর নাম-পাসওয়ার্ড লগইন পদ্ধতিতে কাজ করে। সামাজিক লগইন পদ্ধতির ক্ষেত্রে (Google ইত্যাদি), সাধারণত তৃতীয় পক্ষের দিক থেকে MFA সক্রিয় করা সম্ভব।"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "সিস্টেম পুনরুদ্ধার বা নতুন অপারেটিং সিস্টেম ইনস্টল করার জন্য আপনি একটি বিশেষ ইমেজ থেকে আপনার ভার্চুয়াল মেশিন বুট করতে পারেন। এই মোড সক্রিয় হলে, নির্বাচিত ইমেজটি বুট মিডিয়া হিসেবে সংযুক্ত করা হবে। এরপর আপনি কনসোল ব্যবহার করে আপনার মেশিনে প্রবেশ করতে পারবেন। এই বুট মোডটি শুধুমাত্র বর্তমান চালুর জন্য সক্রিয় থাকবে। পরের বার এই ভার্চুয়াল মেশিন চালু হলে এটি স্বাভাবিক বুট প্রক্রিয়া অনুসরণ করবে।"

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "আপনি এই পৃষ্ঠাটি বন্ধ করতে পারেন।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "আপনি একাধিক বিলিং অ্যাকাউন্ট তৈরি করতে পারেন, যার প্রতিটি নির্দিষ্ট পেমেন্ট পদ্ধতির সঙ্গে যুক্ত থাকবে। এর ফলে বিভিন্ন টিম, বিভাগ বা প্রকল্পের খরচ কার্যকরভাবে আলাদা করে পর্যবেক্ষণ করা সম্ভব হবে।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "আপনি এখান থেকেই এটি করতে পারেন এবং পরে আমরা যে ই-মেইল পাঠাব তার লিঙ্কে ক্লিক করে আবার চালিয়ে যেতে পারবেন।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "আপনার অনন্য রেফারেল কোড শেয়ার করে আপনি বিনামূল্যের ক্রেডিট অর্জন করতে এবং অন্যকে দিতে পারেন।"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr "ভবিষ্যতের জন্য একটি রিজার্ভেশন ইতিমধ্যেই থাকায় আপনি আরেকটি রিজার্ভেশন যোগ করতে পারবেন না।"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr "রিজার্ভেশন নিশ্চিত করার সঙ্গে সঙ্গে আপনি নির্বাচিত সময়ের সম্পূর্ণ মূল্য পরিশোধের অঙ্গীকার করেন।"

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "এই রিসোর্সে একটি ফ্লোটিং আইপি <0>{0}</0> বরাদ্দ করা আছে।"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "অতিরিক্ত বোনাস পাওয়ার জন্য আপনার একটি সক্রিয় ক্যাম্পেইন কোড (<0>{referralCode}</0>) অপেক্ষমাণ রয়েছে!"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "আপনার বিলিং অ্যাকাউন্ট যাচাই প্রক্রিয়া চলমান রয়েছে।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "আপনি বিলিং অ্যাকাউন্ট যাচাই প্রক্রিয়া সম্পন্ন করেছেন। অনুগ্রহ করে চূড়ান্ত সিদ্ধান্তের জন্য অপেক্ষা করুন।"

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "আপনার কোনো বিজ্ঞপ্তি নেই।"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "পেমেন্ট সম্পন্ন করার পর আপনি এই ডায়ালগটি বন্ধ করতে পারেন।"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "আপনি আপাতত এই ডায়ালগ উইন্ডোটি বন্ধ করতে পারেন।"

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr "এই বাকেটের ফাইল ব্রাউজ করতে আপনার অন্তত একটি অ্যাক্সেস কী থাকতে হবে।"

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "যাচাই অনুমোদিত হলে আপনি পেমেন্ট পদ্ধতি সেট আপ করতে এবং ক্লাউড সেবাগুলো ব্যবহার করতে পারবেন।"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "যাচাই সম্পন্ন হলে আপনি পেমেন্ট পদ্ধতি সেট আপ করতে এবং ক্লাউড সেবাগুলো ব্যবহার করতে পারবেন।"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "এটি প্রস্তুত না হওয়া পর্যন্ত আপনার কাছ থেকে কোনো চার্জ নেওয়া হবে না।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "আপনার অ্যাকাউন্ট স্থগিত করা হয়েছে"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "বিনিময় হার <1/> অনুযায়ী, আপনার প্রকৃত চার্জ হবে <0/>।"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "আপনার বিলিং অ্যাকাউন্ট স্থগিত করা হয়েছে। আরও তথ্যের জন্য বিলিং অ্যাকাউন্টের বিস্তারিত দেখুন এবং সমস্যাটি সমাধানের জন্য <0>সাপোর্টের সাথে যোগাযোগ করুন</0>।"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "আপনার বিলিং অ্যাকাউন্টে টপ আপ করা হয়েছে"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "সক্রিয় হতে আপনার বিলিং অ্যাকাউন্টে ধনাত্মক ব্যালান্স থাকতে হবে।"

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "আপনার ইমেইল ঠিকানা সফলভাবে যাচাই করা হয়েছে। আপনি এখন লগ ইন করতে পারেন।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "যাচাই শুরু করার পর থেকে আপনার ই-মেইল ঠিকানা পরিবর্তিত হয়েছে। অনুগ্রহ করে আবার শুরু করুন।"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "আপনার নির্বাচিত বিলিং অ্যাকাউন্টে {discount}% ছাড় রয়েছে"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "আপনার স্টোরেজ বাকেটে অনেক ফাইল রয়েছে, তাই আমরা সাময়িকভাবে লোড করার প্রক্রিয়া বন্ধ রেখেছি। পরবর্তী ব্যাচের ফাইল লোড করতে শুধু \"আরও লোড করুন\" বোতামে ক্লিক করুন।"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "জিপ/পোস্টাল কোড"
